import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssetsRoutingModule } from './assets-routing.module';
import { AssetsComponent } from './assets.component';
import { AssetsEditComponent } from './assets-edit/assets-edit.component';
import { AssetsViewComponent } from './assets-view/assets-view.component';
import { AssetsFilterComponent } from './assets-filter/assets-filter.component';
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatTooltipModule} from "@angular/material/tooltip";
import {PipesModule} from "../pipes/pipes.module";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {UtilsModule} from "../utils/utils.module";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {MatComponentsModule} from "../mat-components/mat-components.module";
import {SharedModule} from "../shared/shared.module";
import {FilesModule} from "../files/files.module";
import { AssetsImporterComponent } from './assets-importer/assets-importer.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {DirectivesModule} from "../directives/directives.module";
import {ClipboardModule} from "ngx-clipboard";
import { AssetsViewFilesComponent } from './assets-view-files/assets-view-files.component';
import { AssetsViewUsersComponent } from './assets-view-users/assets-view-users.component';
import { AssetsViewContractorsComponent } from './assets-view-contractors/assets-view-contractors.component';
import { AssetsViewCorrectiveActionsComponent } from './assets-view-corrective-actions/assets-view-corrective-actions.component';
import { AssetsViewHazardsComponent } from './assets-view-hazards/assets-view-hazards.component';
import { AssetsViewHazardsFilterComponent } from './assets-view-hazards-filter/assets-view-hazards-filter.component';
import { AssetsViewCorrectiveActionsFilterComponent } from './assets-view-corrective-actions-filter/assets-view-corrective-actions-filter.component';
import { AssetsViewUsersFilterComponent } from './assets-view-users-filter/assets-view-users-filter.component';
import { AssetsViewContractorsFilterComponent } from './assets-view-contractors-filter/assets-view-contractors-filter.component';
import { AssetsViewSafetyObservationsComponent } from './assets-view-safety-observations/assets-view-safety-observations.component';
import { AssetsViewIncidentsComponent } from './assets-view-incidents/assets-view-incidents.component';
import { AssetsClaimQrCodeComponent } from './assets-claim-qr-code/assets-claim-qr-code.component';
import { AssetMaintenanceRecordsComponent } from './asset-maintenance-records/asset-maintenance-records.component';
import { AssetMaintenanceRecordsEditComponent } from './asset-maintenance-records/asset-maintenance-records-edit/asset-maintenance-records-edit.component';
import { AssetMaintenanceRecordsViewComponent } from './asset-maintenance-records/asset-maintenance-records-view/asset-maintenance-records-view.component';
import { AssetMaintenanceRecordsFilterComponent } from './asset-maintenance-records/asset-maintenance-records-filter/asset-maintenance-records-filter.component';
import { AssetMaintenanceSchedulesComponent } from './asset-maintenance-schedules/asset-maintenance-schedules.component';
import { AssetMaintenanceSchedulesEditComponent } from './asset-maintenance-schedules/asset-maintenance-schedules-edit/asset-maintenance-schedules-edit.component';
import { AssetMaintenanceSchedulesViewComponent } from './asset-maintenance-schedules/asset-maintenance-schedules-view/asset-maintenance-schedules-view.component';
import { AssetMaintenanceSchedulesFilterComponent } from './asset-maintenance-schedules/asset-maintenance-schedules-filter/asset-maintenance-schedules-filter.component';
import { ActionsModule } from '../actions/actions.module';
import { AssetMaintenanceSchedulesSelectorComponent } from './asset-maintenance-schedules/asset-maintenance-schedules-selector/asset-maintenance-schedules-selector.component';

@NgModule({
  declarations: [
    AssetsComponent,
    AssetsEditComponent,
    AssetsViewComponent,
    AssetsFilterComponent,
    AssetsImporterComponent,
    AssetsViewFilesComponent,
    AssetsViewUsersComponent,
    AssetsViewContractorsComponent,
    AssetsViewCorrectiveActionsComponent,
    AssetsViewHazardsComponent,
    AssetsViewHazardsFilterComponent,
    AssetsViewCorrectiveActionsFilterComponent,
    AssetsViewUsersFilterComponent,
    AssetsViewContractorsFilterComponent,
    AssetsViewSafetyObservationsComponent,
    AssetsViewIncidentsComponent,
    AssetsClaimQrCodeComponent,
    AssetMaintenanceRecordsComponent,
    AssetMaintenanceRecordsEditComponent,
    AssetMaintenanceRecordsViewComponent,
    AssetMaintenanceRecordsFilterComponent,
    AssetMaintenanceSchedulesComponent,
    AssetMaintenanceSchedulesEditComponent,
    AssetMaintenanceSchedulesViewComponent,
    AssetMaintenanceSchedulesFilterComponent,
    AssetMaintenanceSchedulesSelectorComponent
  ],
  exports: [
    AssetMaintenanceSchedulesSelectorComponent
  ],
  imports: [
    CommonModule,
    AssetsRoutingModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    PipesModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    UtilsModule,
    BsDatepickerModule,
    MatComponentsModule,
    SharedModule,
    FilesModule,
    FontAwesomeModule,
    ClipboardModule,
    DirectivesModule,
    ActionsModule
  ]
})
export class AssetsModule {}
